<template>
  <el-dialog
    :title="optType==='set' ? '设置店铺' :'开店铺'"
    :visible.sync="openStoreVisible"
    width="600px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <el-form label-width="100px">
      <el-form-item
        label="店铺名称"
        required
      >
        <el-input
          v-model.trim="create.storeName"
          placeholder="请输入32字以内的店铺名称"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item label="店铺logo">
        <upload
          :image-url="create.storeLogo ? [{url:create.storeLogo}] : []"
          @returnFileInfo="returnFileInfo"
        />
      </el-form-item>
      <el-form-item label="店铺简介">
        <el-input
          v-model.trim="create.storeDesc"
          maxlength="300"
          placeholder="请输入300字以内的店铺简介"
          :autosize="{ minRows: 3, maxRows: 6}"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <div class="m-t-30 m-b-10 text-c">
      <el-button
        type="primary"
        @click="toSubmit"
      >
        确认
      </el-button>
      <el-button @click="handleClose">
        取消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api'
import Upload from '@/components/upload'
function Create () {
  return {
    storeName: '',
    storeLogo: '',
    storeDesc: '',
    marketId: '',
    marketName: '',
  }
}
export default {
  name: 'OpenStore',
  components: {
    Upload
  },
  props: {
    openStoreVisible: {
      type: Boolean,
      default: false,
    },
    storeInfo: {
      type: Object,
      default: () => { return {} },
    },
    optType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      create: new Create(),
      marketList: []
    }
  },
  created () {
    this.create.storeName = this.$store.state.user.info.userName
    this.getMarket()
    if (this.optType === 'set') {
      this.create = this.storeInfo
      this.create.storeLogo = this.storeInfo.storeLogo
    }
  },
  methods: {
    getMarket () {
      api.common.getMarketList().then(res => {
        this.marketList = res.data || []
      })
    },
    returnFileInfo (data) {
      this.create.storeLogo = data && data.length ? data[0].url : ''
    },
    toSubmit () {
      if (this.marketList.length) {
        this.create.marketId = this.marketList[0].k
        this.create.marketName = this.marketList[0].v
      }
      if (!this.create.storeName) {
        this.$message.warning('店铺名称必传')
        return
      }
      const url = this.optType === 'set' ? 'updateStroe' : 'createStore'
      api.myStore[url](this.create).then(res => {
        this.$message.success('操作成功')
        this.handleClose()
        this.$listeners.refresh()
      })
    },
    handleClose () {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
